Shopware.Module.register('topdata-es', {
    type: 'plugin',
    name: 'Topdata Enhanced Search',
    title: 'TopdataEnhancedSearchSW6.nav.mainTitle',
    description: 'TopdataEnhancedSearchSW6.nav.mainTitle',
    color: '#189eff',
    icon: 'default-shopping-search',

    routes: {
        index: {
            path: 'index',
            redirect: {
                name: 'topdata.es.synonym.list',
            },
        },
    },

    navigation: [{
        id: 'topdata-es',
        label: 'TopdataEnhancedSearchSW6.nav.mainTitle',
        parent: 'sw-content',
        position: 100,
    }],
});
